import { colors, Select, TextArea } from '@insurancemenu/imenu-components-lib';
import { FileEdi } from '@insurancemenu/imenu-components-lib/dist/icons';
import FormModal from 'components/common/modals/FormModal';
import React, { useState } from 'react';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

export interface GenerateFileModalProps {
  defaultSponsorId: string;
  isModalOpen: boolean;
}

const GenerateFileModal = ({ defaultSponsorId, isModalOpen }: GenerateFileModalProps): JSX.Element => {
  const classes = createStyles();
  const [sponsorId, setSponsorId] = useState(defaultSponsorId);
  const [policyIds, setPolicyIds] = useState('');

  const {
    readyToSendEdisStore: { getExchangeReadyFiles, closeModal, generateEdiFile },
    filesTrackingController: { getSponsorOptions },
  } = useRootStore();

  const generateFile = async (): Promise<void> => {
    const convertedPolicyIds = policyIds ? policyIds.split(',').map((id) => id.trim()) : [];
    await generateEdiFile(sponsorId, convertedPolicyIds);
    closeModal();
    void getExchangeReadyFiles(sponsorId);
  };

  const ModalContent = (
    <div className={classes.formContent}>
      <Select
        label="Sponsor Id"
        name="sponsorId"
        options={getSponsorOptions()}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
          setSponsorId(e.target.value);
        }}
        value={sponsorId}
        width="25rem"
        validationPassed={!!sponsorId}
        validationMessage="Required"
        className={classes.sponsorSelect}
      />
      <TextArea
        name="policies"
        label="Policy Ids"
        description={<span className={classes.textAreaDescription}>Separate IDs using commas (,)</span>}
        value={policyIds}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): void => {
          setPolicyIds(e.target.value);
        }}
        width="100%"
        height="15rem"
      />
    </div>
  );

  return (
    <FormModal
      show={isModalOpen}
      title="Generate File"
      subtitle={
        <span>You can leave the policy IDs empty to find all valid files, or input IDs for specific files.</span>
      }
      onClose={closeModal}
      submitButtonText="Generate File"
      onSubmit={generateFile}
      icon={<FileEdi width="4.8rem" color={colors.green[600]} />}
      formContent={ModalContent}
      isFormValid={!!sponsorId}
    />
  );
};

export default GenerateFileModal;
